export const ROUTES = {
  NOTIFICATION_BASE: "/notifications",
  NOTIFICATION_DETAILS: "/notifications/details",
  NOTIFICATION_LIST: "/notifications", // Default fallback
  NOTIFICATION_INSTANT_LIST: "/notifications?Providers=INSTANT",
  NOTIFICATION_EMAIL_LIST: "/notifications?Providers=EMAIL",
  NOTIFICATION_PUSH_LIST: "/notifications?Providers=FIREBASE",
  NOTIFICATION_CREATE: "/notifications/create",
};
